import type { ExpensesV2FilterResponse } from 'types/global.types';

export const adaptFilters = (data: ExpensesV2FilterResponse[]) => {
  return data.map((f) => ({
    ...f,
    label: f.title,
    options:
      f.options?.map((o) => ({
        label: o.title,
        value: o.key,
      })) || [],
  }));
};
